export default __webpack_public_path__ + "static/media/background.2047b26a.jpg";